import { RootState } from "@/store/store";
import { providerOrganizationsDataSelector } from "@/store/commitments/selectors/organisations/providerOrganizationsDataSelector";

export const commitmentsOrganizationsSelector = (
  state: RootState,
  enableAzure: boolean = true,
) => {
  return providerOrganizationsDataSelector(state)?.filter(
    (org) =>
      org.cloud_provider === "aws" ||
      (enableAzure && org.cloud_provider === "azure"),
  );
};
